@if (lightbox$ | async; as state) {
  <app-image-lightbox
    [state]="state"
    (close)="onClose()"
    (next)="onNext()"
    (previous)="onPrevious()"
    (select)="onSelect($event)"
  />
}
